module.exports = __webpack_public_path__ + "media/images/pc/specials/common/icon_number_01-50797f6390c97d4524dbe42a1437728f.svg";